"use strict";



(function(){
    let name = '';
    let a = 0,
        b = 0,
        c = 0,
        last_entree = '';
    
    const btnConfirm = $('.confirm'),
        btnPrevious = $('.previos'),
        btnStart = $('.btn_start'),
        btnNext = $('.btn_next'),
        inputName = $('.input-name');
        


   const questNumber = $('.number-question'),
        blockStartPage = $('.start-page'),
        blockName = $("#name-block"),
        questionBlock = $("#questions-block"),
       finalWindow = $('#final-window');
    
    
    btnConfirm.attr('disabled', true);
    btnPrevious.attr('disabled', true);
    console.log($('div[data-quest]').length);
    questNumber.text($('div.now').data('quest')+' из '+$('div[data-quest]').length);
    btnStart.on('click', function(){

        blockStartPage.fadeOut(800, function(){

            $('.start-rules').addClass('none');
            blockName.fadeIn(800);


        });

    });
    btnNext.on('click', function (e) {
        e.preventDefault();
        if(inputName.val().trim() !== '' && inputName.val().trim().length >= 2){
            $('.error-name').addClass('none');
            $('.error-name-length').addClass('none');
            console.log(inputName.val().trim().length);
            name = inputName.val()+', ';
            blockName.fadeOut(800, function(){
                questionBlock.fadeIn(800);
                $('.name-paste').each(function (index, element) {
                    element.prepend(name);
                })
            });
        }
        else if(inputName.val().trim().length >= 1 && inputName.val().trim().length < 2){

            $('.error-name').addClass('none');
            $('.error-name-length').removeClass('none');
        }
        else{
            $('.error-name-length').addClass('none');
            $('.error-name').removeClass('none');
        }

    });
    $('.skip-name').on('click', function (e) {
        e.preventDefault();
        name = '';
        blockName.fadeOut(1400, function(){
            questionBlock.fadeIn(1400);
            $('.name-paste').each(function (index, element) {
                element.textContent = element.textContent.trim()[0].toUpperCase() + element.textContent.trim().substring(1);

            })
        });
    });


    $('input').change(function(){
        if(this.checked){
            btnConfirm.attr('disabled', false);

        }
    });


    btnConfirm.on('click', function(e){
        var curr = $('.question.now');
        btnConfirm.attr('disabled', true);
        if(curr.find('input:checked').length == 1){
            if(curr.find('input:checked').val() == 1){
                a++;
                last_entree = 'a';

            }
            if(curr.find('input:checked').val() == 2){
                b++;
                last_entree = 'b';
            }
            if(curr.find('input:checked').val() == 3){
                c++;
                last_entree = 'b';
            }
            questNumber.text((curr.data('quest')+1)+' из '+$('div[data-quest]').length)
            var next = curr.next();

            if(next.prop('tagName') != 'DIV'){
                questNumber.hide();
                questionBlock.fadeOut(400, function(){
                    finalWindow.fadeIn(400, function(){

                        if(a>b && a>c){
                            $('.var-moreA').removeClass('none');

                        }
                        else if(b>a && b>c){
                            $('.var-moreB').removeClass('none');

                        }
                        else if(c>a && c>b){
                            $('.var-moreC').removeClass('none');

                        }
                        else if(a === b && a > c ){
                            $('.var-moreAB').removeClass('none');
                        }
                        else if(b === c && c > a){
                            $('.var-moreBC').removeClass('none');
                        }
                        else if(a === c && a > b){
                            $('.var-moreAC').removeClass('none');
                        }
                    });
                })
            }
            else{
                curr.fadeOut(400, function(){
                    next.fadeIn(400, function(){
                        // if(next.next().prop('tagName') != 'DIV'){
                        //     btnConfirm.text('Finish');
                        //
                        // }

                        if(next.find('input:checked').length == 1){
                            btnConfirm.attr('disabled', false);
                        }
                        else{
                            btnConfirm.attr('disabled', true);
                        }
                        curr.removeClass('now');
                        next.addClass('now');
                        btnPrevious.attr('disabled', false);



                    });
                });
            }

        }

    })

    btnPrevious.on('click', function(){
        var curr = $('.question.now');
        var prev = curr.prev();

        if(last_entree == 'a'){
            a--;

        }
        if(last_entree == 'b'){
            b--;
        }
        if(last_entree == 'c'){
            c--;
        }
        questNumber.text((curr.data('quest')-1)+' из '+$('div[data-quest]').length);


        curr.fadeOut(400, function(){
            prev.fadeIn(400, function(){
                curr.removeClass('now');
                prev.addClass('now');
                if(prev.data('quest') == 1){
                    btnPrevious.attr('disabled', true);

                }
                else{
                    btnPrevious.attr('disabled', false)
                }

                btnConfirm.attr('disabled', false).text('Ответить');
            });
        });
    });
    $('#form-15proc').validate({
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parent("div"));
        },
        ignore: ":hidden",
        rules: {
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
                minlength: 18,
                maxlength: 18,
            },
            personal: {
                required: true,
            },
        },
        messages: {
            email: {
                required: "Пожалуйста введите email",
                email: "Введите корректный email"

            },
            phone: {
                required: "Пожалуйста введите телефон",
                minlength: "Телефон введен неполностью",
            },
            personal: {
                required:
                    "Подтвердите, согласие на обработку персональных данных",
            }
        },
        submitHandler: function (form) {
            submitFormLead(form);
        },
    });


    $.fancybox.defaults.autoFocus = "true";
    $.fancybox.defaults.trapFocus = "true";
    $.fancybox.defaults.touch = {
        vertical: false, // Allow to drag content vertically
        momentum: false, // Continue movement after releasing mouse/touch when panning
    };
    ($.fancybox.defaults.beforeShow = function () {
        $("body").css({ "overflow-y": "hidden" });
    }),
        ($.fancybox.defaults.afterClose = function () {
            $("body").removeAttr("style");
        });
    $.fancybox.defaults.autoFocus = "true";

    // $('.close').on('click', function (e) {
    //     e.preventDefault();
    //     $.fancybox.close();
    // });

    function openSanks(name) {
        $.fancybox.close();
        $.fancybox.open($(name));
    }

    $('.btn_5proc').on('click', function (e) {
        openSanks("#popup-5proc");
    });

    //попап для
    // Ловите на почте купон со скидкой 15%.
    // Используйте его для покупок
    // в Перекрёстке.

    // openSanks("#popup-15proc");


    //попап для
    // Пока вы не поставите галочки,
    // мы не сможем прислать купон
    // со скидкой 15% :(

    // openSanks("#popup-cant-send-mail");


    //попап для
    // Купон со скидкой 15% уже летит к вам.
    // Скорее открывайте следующее письмо!

    // openSanks("#popup-sent-mail");


    //попап для
    // Ой, похоже, что вы уже получали скидку.

    // openSanks("#popup-second-try");


})();




